import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';

export const NotiStackButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(grey[200]),
  backgroundColor: 'white',
  '&:hover': {
    backgroundColor: grey[200],
  },
})) as typeof Button;
